import { render, staticRenderFns } from "./WidgetEditable.vue?vue&type=template&id=105d8a9d&"
import script from "./WidgetEditable.vue?vue&type=script&lang=js&"
export * from "./WidgetEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105d8a9d')) {
      api.createRecord('105d8a9d', component.options)
    } else {
      api.reload('105d8a9d', component.options)
    }
    module.hot.accept("./WidgetEditable.vue?vue&type=template&id=105d8a9d&", function () {
      api.rerender('105d8a9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/WidgetEditable.vue"
export default component.exports